import { Card, CardContent } from '@e2n/ui/v2';
import { useDatevAuthContext } from '../../lib/DatevAuthContext';
import { Authorized } from './Authorized';
import { NotAuthorized } from './NotAuthorized';

export function DatevAuthCard() {
  const { status } = useDatevAuthContext();

  const isAuthorized = !!status?.authorized;

  return (
    <Card>
      <CardContent>
        {isAuthorized ? <Authorized /> : <NotAuthorized />}
      </CardContent>
    </Card>
  );
}
